"use client";

import { useLocale, useTranslations } from "next-intl";
import { useParams } from "next/navigation";
import dayjs, { Dayjs } from "dayjs";
import tz from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import LocalisedFormat from "dayjs/plugin/localizedFormat";
import { useModal } from "@/components/contexts/modal";
import { AxiosCargo, EStatusCode, NotificationProps } from "./declarations";
import FailModal from "@/components/modals/fail-modal";
import { redirect, useRouter } from "@/i18n/routing";
import { useCallback } from "react";
import { useFirebase } from "@/components/contexts/firebase";
dayjs.extend(tz);
dayjs.extend(utc);
dayjs.extend(LocalisedFormat);
export const usePromotionName = () => {
  const { locale } = useParams();
  const t = useTranslations();
  return (title: string) => {
    try {
      const name = JSON.parse(title)[locale === "bn-bd" ? "in" : (locale as string)] as string;
      if (name === "") {
        throw new Error("EMPTY_TITLE");
      }

      return name;
    } catch (e) {
      if (e instanceof Error) {
        if (e.message === "EMPTY_TITLE") {
          return t("no-title");
        }
      }
      return title;
    }
  };
};

export const useTZDate = () => {
  dayjs.tz.setDefault("UTC");
  const func = (date: string, format: string = "llll") => {
    const source = dayjs.tz(date);
    return source.tz("Asia/Dhaka").format(format);
  };
  return func;
};

export const useAxiosCargoCustom = () => {
  // const locale = useLocale();
  const t = useTranslations();
  const { openModal } = useModal();
  const router = useRouter();

  async function AxiosCargoCustom<T>(data: AxiosCargo<T>) {
    const response = await data;
    switch (response.status) {
      case EStatusCode.SUCCESS:
        console.log("RESPONSE: ", response);
        return response.data;
      case EStatusCode.INTERNAL_SERVER_ERROR:
        console.log("INTERNAL_SERVER_ERROR: ", response.data);
        // /en internal-server-error: "Internal Server Error"
        // /bn internal-server-error: "অভ্যন্তরীণ সার্ভার ত্রুটি"

        openModal(<FailModal description={t("internal-server-error")} />, t("failed-to-fetch-data"));
        break;
      case EStatusCode.UNAUTHORIZED:
        console.log("UNAUTHORIZED: ", response.data);
        // /en session-ended-title: "Session Ended"
        // /bn session-ended-title: "সেশন শেষ"
        // /en session-ended-description: "Your session has ended. Please login again"
        // /bn session-ended-description: "আপনার সেশন শেষ হয়েছে। দয়া করে আবার লগইন করুন"
        openModal(<FailModal description={t("session-ended-description")} />, t("session-ended-title")).then(() => {
          router.push("/logout");
        });
        // redirect({ locale, href: "/login" });
        break;
      default:
        console.log("UNKNOWN_ERROR: ", response.data);
        return null;
    }
    return null;
  }

  return AxiosCargoCustom;
};

export const useDepositSucceedEvent = (dep: any[]) => {
  const { pushEvent } = useFirebase();
  return useCallback(
    (e: NotificationProps) => {
      pushEvent("deposit_succeed", {
        amount: e.amount,
        username: e.username,
        payment_provider: e.payment_provider,
        payment_method: e.payment_method,
      });
      // if (window.dataLayer) {
      //   window.dataLayer.push({
      //     event: "deposit_succeed",
      //     amount: e.amount,
      //     username: e.username,
      //     payment_provider: e.payment_provider,
      //     payment_method: e.payment_method,
      //   });
      // }
    },
    [...dep]
  );
};
